import { createElementBlock as l, openBlock as o, createElementVNode as r } from "vue";
const t = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
};
function n(a, e) {
  return o(), l("svg", t, e[0] || (e[0] = [
    r("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M2.106 2.553a1 1 0 0 1 1.341-.447l1 .5a1 1 0 1 1-.894 1.788l-1-.5a1 1 0 0 1-.447-1.341m3.869 1.596a1 1 0 0 1 .972-.043l3 1.5a1 1 0 0 1-.894 1.788l-1.554-.777-.006 6.615c2.193.733 3.605 2.533 3.934 4.724h4.76a3.001 3.001 0 1 1-.031 2H10.5a1 1 0 0 1-1-1c0-2.01-1.192-3.574-3.204-3.975a1 1 0 0 1-.804-.982l.008-9a1 1 0 0 1 .475-.85M19 20a1 1 0 1 0 0-2 1 1 0 0 0 0 2M6 19a1 1 0 1 1-2 0 1 1 0 0 1 2 0m2 0a3 3 0 1 1-6 0 3 3 0 0 1 6 0",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const d = { render: n };
export {
  d as default,
  n as render
};
//# sourceMappingURL=ic_scooter-CZEOfKdv.js.map
